<script setup lang="ts"></script>

<template>
  <div>
    <NuxtPage />
  </div>
</template>
